import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Footer from "../components/Footer";
import PrivacyPolicy from "../components/PrivacyPolicy";
import { Helmet } from "react-helmet-async";

const PrivacyPolicyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | TimeWatch Infocom</title>
        <meta
          name="description"
          content="Read TimeWatch Infocom’s Privacy Policy to understand how we protect your personal information. As a leading provider of biometric solutions, access control systems, and smart security technologies, we are committed to safeguarding your data while delivering innovative security solutions. Our privacy practices ensure compliance with industry standards, keeping your information secure when using our services, including time attendance systems, entrance automation, and parking management solutions. Learn more about how we collect, store, and use your data to provide reliable and secure technology solutions."
        />
        <link
          rel="canonical"
          href="https://www.timewatchindia.com/privacy-policy"
        />
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="policy">
          <PrivacyPolicy />
        </section>
      </div>

      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default PrivacyPolicyPage;
